import Highcharts from 'highcharts'
import {theme} from './theme.js'
import moment from 'moment'
// Highcharts.setOptions(theme);
var pickerOptions2={
  shortcuts: [{
    text: '最近一周',
    onClick(picker) {
      const start_time = moment(moment().startOf('isoWeek')).valueOf()
      const end_time = moment(moment().endOf('isoWeek')).valueOf() + 1000
      const start = new Date(start_time - 3600 * 1000 * 24 * 7)
      const end = new Date(end_time - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const brforeOneMonth = moment().month(moment().month() - 1)
      const start_time = moment(brforeOneMonth.format('YYYY-MM')).valueOf()
      const end_time = moment(moment().startOf('month')).valueOf()
      const start = new Date(start_time)
      const end = new Date(end_time)
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      // 获取当前月
      const brforeThreeMonth = moment().month(moment().month() - 3)
      const start_time = moment(brforeThreeMonth.format('YYYY-MM')).valueOf()
      const end_time = moment(moment().startOf('month')).valueOf()
      const start = new Date(start_time)
      const end = new Date(end_time)
      picker.$emit('pick', [start, end]);
    }
  }]
}

var option = {
  chart: {
    zoomType: 'xy',
  },
  title: {
    text: ''
  },
  subtitle: {
      text: ''
  },
  credits:{
    enabled: false // 禁用版权信息
  },
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%m-%d',
        week: '%m-%d',
        month: '%Y-%m',
        year: '%Y-%m'
    },
    tickPositioner:function(){
      if(this.chart.series[0].userOptions.timetype=='week'|| this.chart.series[0].userOptions.timetype == 'period'){
        return this.chart.series[0].processedXData
      }
    },
    labels: {
        style: {
          // fontSize: '32px'
        },
        // step:2,
        formatter:function(){
          let timetype=this.chart.series[0].userOptions.timetype
          let str = ''
          switch (timetype) {
            case 'min':
              str = moment(this.value).format('HH:mm')
              if (moment(this.value).format('m') == '0') {
                // str = moment(this.value).format('YY年M月D日')
                str = moment(this.value).format('D日HH:mm')
              } else {
                str = moment(this.value).format('HH:mm')
              }
              break;
            case 'day':

              if (moment(this.value).format('D') == '1') {
                str = moment(this.value).format('YY年M月D日')
              } else {
                str = moment(this.value).format('M月D日')
              }
              break;
            case 'hour':

              if (moment(this.value).format('H') == '0') {
                str = moment(this.value).format('M月D日H时')
              } else {
                str = moment(this.value).format('DD日H时')
              }
              break;
            case 'period':
              if (moment(this.value).format('D') == '1') {
                str = moment(this.value).format('M')+'月上旬'
              } else if (moment(this.value).format('D') == '11') {
                str = moment(this.value).format('M') + '月中旬'
              } else {
                str = moment(this.value).format('M') + '月下旬'
              }
              break;
            case 'month':
              if(moment(this.value).format('YYYY')!= moment(this.value).add(1,'month').format('YYYY')){
                str = moment(this.value).format('YYYY')+'年'+moment(this.value).format('M') + '月'
              }else{
                str = moment(this.value).format('M') + '月'
              }

              break
            case 'week':
              if(moment(this.value).format('M')!= moment(this.value).add(6,'days').format('M')){
                str = moment(this.value).format('M月D日') + '~' + moment(this.value).add(6, 'days').format('M月D日')
              }else{
                str = moment(this.value).format('D日') + '~' + moment(this.value).add(6, 'days').format('D日')
              }
              break
            case 'year':
              str = moment(this.value).format('YYYY')+'年'
              break
          }
          return str
        }
      }
  },
  yAxis: {
    title: {
      text: ''
    },
    min:0
  },
  tooltip: {
    // valueDecimals:1,
    shared: true,
    crosshairs: true,
    formatter:function(){
      let timetype=this.points[0].point.series.userOptions.timetype
      let p=this.points[0]
      let str=''
      switch(timetype){
        case 'min':
          str=moment(p.x).format('YYYY-MM-DD HH:mm')
          break;
        case 'day':
          str= moment(p.x).format('YYYY-MM-DD')
          break;
        case 'hour':
          str = moment(p.x).format('YYYY-MM-DD HH时')
          break;
        case 'period':
          if(moment(p.x).format('DD')=='01'){
            str = moment(p.x).format('YYYY-MM-01')+'~'+ moment(p.x).format('MM-11')
          }else if(moment(p.x).format('DD') == '11'){
            str = moment(p.x).format('YYYY-MM-11') + '~' + moment(p.x).format('MM-21')
          }else{
            str = moment(p.x).format('YYYY-MM-21') + '~' + moment(p.x).endOf('month').format('MM-DD')
          }
          break;
        case 'month':
          str = moment(p.x).format('YYYY-MM-01') + '~' + moment(p.x).endOf('month').format('MM-DD')
          break
        case 'week':
          str = moment(p.x).format('YYYY-MM-DD') + '~' + moment(p.x).add(6,'days').format('MM-DD')
          break
      }
      str+='<br>'
      for(let item of this.points){
        str += `<span style="color:${item.color}">${item.series.name}</span> : <span>${item.y} ug/m3</span><br>`
      }
      return str
    },
    dateTimeLabelFormats: {
        second: '%Y-%m-%d %H:%M:%S',
        minute:'%Y-%m-%d %H:%M',
        hour:'%Y-%m-%d %H',
        day:'%Y-%m-%d',
        week:'%Y-%m-%d',
        month:'%Y-%m',
        year:'%Y',
    }
  },
  series: [],
  responsive: {
      rules: [{
          condition: {
              maxWidth: 500
          },
          chartOptions: {
              legend: {
                  layout: 'horizontal',
                  align: 'center',
                  verticalAlign: 'bottom'
              }
          }
      }]
  }
}

var option_window = {
    chart:{
      zoomType:'xy'
    },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    yAxis: {
        title: {
            text: 'ug/m3'
        },
        min:0
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
          millisecond: '%H:%M:%S.%L',
          second: '%H:%M:%S',
          minute: '%H:%M',
          hour: '%H:%M',
          day: '%m-%d',
          week: '%m-%d',
          month: '%Y-%m',
          year: '%Y'
      },
      plotLines:[]
    },
    tooltip: {
      shared: true,
      crosshairs: true,
      valueDecimals:0,
      dateTimeLabelFormats: {
          second: '%Y-%m-%d %H:%M:%S',
          minute:'%Y-%m-%d %H:%M',
          hour:'%Y-%m-%d %H',
          day:'%Y-%m-%d',
          week:'%Y-%m-%d',
          month:'%Y-%m',
          year:'%Y',
      }
    },
    legend: {
      // enabled:false
        // layout: 'vertical',
        // align: 'right',
        // verticalAlign: 'middle'
    },
    plotOptions: {
        series: {

        }
    },
    series: [],
    responsive: {
        rules: [{
            condition: {
                maxWidth: 500
            },
            chartOptions: {
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                }
            }
        }]
    }
}

let option_24h = {
  chart: {
    type: 'column'
  },
  title: {
    text: ''
  },
  subtitle: {
    text: ''
  },
  xAxis: {
    categories: [
    ],
    crosshair: true
  },
  yAxis: {
    min: 0,
    title: {
      text: ''
    }
  },
  tooltip: {
    shared: true,
  },
  plotOptions: {
    column: {
      borderWidth: 0
    }
  },
  series: [{
    name: '',
    data: []
  },
  {
    name: '',
    data: []
  },
  {
    name: '',
    data: []
  },
  {
    name: '',
    data: []
  },
  {
    name: '',
    data: []
  },
  ]
}



var pm25RangeColor = []
var pm10RangeColor = []
var pm25RangeColor2 = []
var pm10RangeColor2 = []
let pm25_max = 700
let pm10_max = 700

for (var i of pmcolors){

  // var pm25_r = Math.round((i.highval_pm25/pm25_max)*100)/100
  // var pm10_r = Math.round((i.highval_pm10/pm10_max)*100)/100
  // if (pm25_r > 1 || pm10_r>1){
  //   continue
  // }
  // pm25RangeColor[pm25_r] = i.bgcolor
  // pm10RangeColor[pm10_r] = i.bgcolor
  // pm25RangeColor2[pm25_r] = i.bgcolor2
  // pm10RangeColor2[pm10_r] = i.bgcolor2
  let pm25_r = ((i.lowval_pm25 + i.highval_pm25)/2/pm25_max)
  let pm10_r = ((i.lowval_pm10 + i.highval_pm10)/2/pm10_max)
  if (pm25_r > 1){
    pm25_r=1
  }
  if(pm10_r >1){
    pm10_r = 1
  }
  if (pm25_r < 0){
    pm25_r = 0
  }
  if (pm10_r < 0){
    pm10_r = 0
  }
  pm25RangeColor.push({r:pm25_r,c:i.bgcolor})
  pm10RangeColor.push({r:pm10_r,c:i.bgcolor})

  pm25RangeColor2.push({r:pm25_r,c:i.bgcolor2})
  pm10RangeColor2.push({r:pm10_r,c:i.bgcolor2})
}

var colorRange1 = {pm25: pm25RangeColor,pm10: pm10RangeColor}
var colorRange2 = {pm25: pm25RangeColor2,pm10: pm10RangeColor2}

const option_region = [
  {label:'全市', value:727},
  {label:'商河县', value:736},
  {label:'章丘', value:737},
  {label:'高新区', value:738},
  {label:'南部山区', value:739},
  {label:'历下区', value:728},
  {label:'市中区', value:729},
  {label:'槐荫区', value:730},
  {label:'天桥区', value:731},
  {label:'历城区', value:732},
  {label:'长清区', value:733},
  {label:'平阴县', value:734},
  {label:'济阳县', value:735},
]

let timeGroupOption=[
  {name: '分钟', value: '1m', value2:'min'},
  {name: '时均', value: '1h', value2:'hour'},
  {name: '日均', value: '1d', value2:'day'},
  {name: '周均', value: '1w', value2:'week'},
  {name: '月均', value: '1mon', value2:'month'},
  {name: '年均', value: '1y', value2:'year'},
]
let poll_title = "某微站周边5km所有微站均值作为背景，该微站分钟PM值比背景×1.1倍高的定义为其局部污染指数，将某时间范围内，空间范围内相关微站的局部污染指数积分求平均作为该区域对应时间范围内的局部污染指数。"
let tpOptions =[
  {name:'PM₂.₅', value: 'pm25', title: 'PM₂.₅'},
  {name:'PM₁₀', value: 'pm10', title: 'PM₁₀'},
  { value: "no2", title: "NO₂", name: "NO₂"},
  {name:'PM₂.₅局部污染指数', value: 'pm25_pollution', title: poll_title},
  {name:'PM₁₀局部污染指数', value: 'pm10_pollution', title: poll_title},
  {name:'SO₂局部污染指数', value: 'so2_f_pollution', title: poll_title, model: 'pro'},
  {name:'NO₂局部污染指数', value: 'no2_pollution', title: poll_title},
  {name:'O₃局部污染指数', value: 'o3_pollution', title: poll_title, model: 'pro'},
  {name:'CO局部污染指数', value: 'co_f_pollution', title: poll_title, model: 'pro'},

  {name:'尘源识别', value: 'pm10_pm25', title: 'PM₁₀/PM₂.₅', barModel: 'ord'},
  {name:'PM₁₀尘源识别', value: 'pm10_p', title: 'PM₁₀尘源识别', barModel: 'ord'},

  
  { value: "o3", title: "O₃", name: "O₃", model: 'pro'},
  { value: "so2_f", title: "SO₂", name: "SO₂", model: 'pro'},
  { value: "tvoc", title: "VOCs", name: "VOCs", model: 'pro'},
  { value: "co_f", title: "CO", name: "CO", model: 'pro'},

  {name:'大颗粒污染(1)', value: 'pm_large', title: '大颗粒污染(1)', model: 'pro'},
  {name:'大颗粒污染(2)', value: 'pm_large_2', title: '大颗粒污染(2)', model: 'pro'},
  {name:'小颗粒污染(1)', value: 'pm_small', title: '小颗粒污染(1)', model: 'pro'},
  {name:'小颗粒污染(2)', value: 'pm_small_2', title: '小颗粒污染(2)', model: 'pro'},
]

let menu029options = [
  {name:'6通道', value: 'channels6', title: '6通道'},
  {name:'31通道', value: 'channels31', title: '31通道'}
]

const menuPoPOptions = [
  {name:'PM₁₀环比', value: 'pm10_PoP', title: 'PM₁₀环比'}, // Period-over-Period
]

let name_options = {
  'pm25': 'PM₂.₅',
  'pm10': 'PM₁₀',
  'pm25_pollution': 'PM₂.₅_局部污染指数',
  'pm10_pollution': 'PM₁₀_局部污染指数',
  'pm10_pm25': '粒径比例',
  'pm_large': '大颗粒污染(1)',
  'pm_large_2': '大颗粒污染(2)',
  'pm_small': '小颗粒污染(1)',
  'pm_small_2': '小颗粒污染(2)',
  'pm10_p': 'PM₁₀尘源识别',
  'no2': "NO₂",
  'o3': "O₃",
  'so2_f': "SO₂",
  'tvoc': "VOCs",
  'co': "CO",
  'co_f': "CO",
  "no2_pollution": "NO₂_局部污染指数",
  "o3_pollution": "O₃_局部污染指数",
  "so2_f_pollution": "SO₂_局部污染指数",
  "tvoc_pollution": "VOCs_局部污染指数",
  "co_f_pollution": "CO_局部污染指数",
  "pm10_PoP": "PM₁₀环比"
}

let text_options = {
  textKey:'count',
  draw: 'text',
  avoid: true,
  size: 12,
  font: '18px Arial',
  fillStyle: 'white',
  shadowBlur: 10,
  fontColorRange:[]
}

let gf_level_options = {
  '国': 1,
  '省': 2,
  '市': 3,
  '街镇': 4,
}



let chartColors = {
  1: '#098ec4',
  2: '#4ba946',
  3: '#f67e2a',
  4: '#c7a7d2',
  5: '#d7df3f',
}

const get029Values = (n) => {
  let str = `PMCH31_`
  if(n === 6) {
    str = `PMCH06_`
  }
  let arr = []
  for(let i=1; i<=n; i++) {
    if(i < 10) {
      arr.push(str+"0"+i)
    } else {
      arr.push(str+i)
    }
  }
  return arr;
}

const channels6Values = get029Values(6)
const channels31Values = get029Values(31)

export {pickerOptions2,option,colorRange1,colorRange2,option_region,timeGroupOption,tpOptions,text_options,gf_level_options,option_window,option_24h,name_options,chartColors,channels6Values,channels31Values,menu029options,menuPoPOptions}



// WEBPACK FOOTER //
// ./src/options/option.js